import { Fragment, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { DocumentSerieEditCrumbs } from 'civil-status/constants/document-serie-breadcrumb';
import FormDocumentSerie, { DocumentSerieForm } from 'civil-status/components/document-serie/form';
import { useNavigate, useParams } from 'react-router-dom';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { toast } from 'react-toastify';
import { __CIVIL_STATUS_API_URL__ } from 'shell/constants/environment';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { HttpResponse } from 'shell/models/http-response';
import { DocumentSerie } from 'shell/models/document-serie';
import { transformResponseDocumentSerie } from 'civil-status/utils/transformer-document-serie';

const DocumentSerieEditPage = (): React.ReactElement => {
  const navigate = useNavigate();

  const params = useParams();

  const updateSerie = useHttpClient(`${__CIVIL_STATUS_API_URL__}/serie-atto/aggiorna-serie-atto`, {
    options: {
      method: 'PUT',
    },
  });

  const [serie] = useHttpFetch<HttpResponse<DocumentSerie>, DocumentSerieForm>(
    `${__CIVIL_STATUS_API_URL__}/serie-atto/${params.id}`,
    {
      onBootstrap: true,
      transformer: transformResponseDocumentSerie,
    }
  );

  const serieData = serie.data as DocumentSerieForm;

  const handleSubmit = useCallback(
    (values) => {
      (
        updateSerie({
          data: {
            key: {
              codiceSerie: params.id,
            },
            serie: values.description,
          },
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/stato-civile/serie');
      });
    },
    [updateSerie, navigate]
  );

  const isLoading = serie.isLoading || serie.pristine || serie.hasErrors;

  return (
    <Fragment>
      <Breadcrumbs items={DocumentSerieEditCrumbs} />
      {!isLoading ? (
        <FormDocumentSerie
          title={'Modifica Serie'}
          onOk={handleSubmit}
          onCancel={() => {
            navigate('/stato-civile/serie');
          }}
          isEdit
          initialValues={serieData}
        ></FormDocumentSerie>
      ) : undefined}
    </Fragment>
  );
};

DocumentSerieEditPage.displayName = 'Document Serie Edit page component';

export default DocumentSerieEditPage;
